import BigPopupNoHeaderTemplate from "components/templates/modal/big/BigPopupNoHeaderTemplate";
import * as s from "./CvvStyled";
import { Text } from "components/atoms/text/Text";
import { Option } from "utils/options";
import { getAccountTimeFormatDate, getTimezoneAbbr } from "utils/timeUtil";
import { CvvBase } from "./CvvContainer";
import {
  CVVPairItem,
  DayNightItem,
} from "api/interfaces/reportInterface.interface";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import CLOSE_ICON from "assets/icons/sidenav/x.svg";
import WARNIN_CIRCLE_ICON from "assets/icons/warning_circle.svg";
import CVVThumbnail from "components/atoms/image/thumbnail/CVVThumbnail";
import SmallLabel from "components/atoms/text/labels/SmallLabel";
import { COLORS } from "styles/colors";
import { checkCVVError, checkCVVErrorBlocking, checkEmpty } from "utils/functions";
import { useAppSelector } from "redux/hooks";
import { cvvEvent } from "./constants";

type Props = {
  data: DayNightItem;
  selectFilterRecorder: string;
  recorderList: Option[];
  renderDataName: () => string;
  popupBase: CvvBase;
  currentPairItem: CVVPairItem | null;
  setIsCvvOpen: React.Dispatch<React.SetStateAction<boolean>>;
  timezoneOffset: number;
  timezone: string;
};

export default function CvvDetailPopup(props: Props) {
  const {
    data,
    selectFilterRecorder,
    recorderList,
    renderDataName,
    popupBase,
    currentPairItem,
    setIsCvvOpen,
    timezoneOffset,
    timezone,
  } = props;

  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const date =
    popupBase === CvvBase.EVENT
      ? currentPairItem!.eventThumbnail.date
      : currentPairItem!.referenceThumbnail.date;
  return (
    <BigPopupNoHeaderTemplate>
      <s.ModalHeader>
        <s.ModalInfo>
          <s.CameraHeaderItem>
            <Text className="cvv-header-title">Recorders</Text>
            <Text bold>
              {selectFilterRecorder !== undefined && selectFilterRecorder !== ""
                ? recorderList.find(
                    (option) => option.value === selectFilterRecorder
                  )?.label
                : ""}
            </Text>
          </s.CameraHeaderItem>

          <s.CameraHeaderItem>
            <Text className="cvv-header-title">Camera</Text>
            <Text bold>{renderDataName()}</Text>
          </s.CameraHeaderItem>

          <s.CameraHeaderItem>
            <Text className="cvv-header-title">Date / Time</Text>
            <Text bold>
              {date && timezone
                ? `${getAccountTimeFormatDate(
                    date,
                    { ...selectedAccount, timezone: "UTC" },
                    true,
                    true
                  ).replace(" GMT", "")} ${getTimezoneAbbr(timezone)}`
                : ""}
            </Text>
          </s.CameraHeaderItem>
        </s.ModalInfo>

        <button
          onClick={() => setIsCvvOpen(false)}
          data-testid="reports-view-cvv-button-set-is-cvv-open"
        >
          <img alt="close button" src={CLOSE_ICON} />
        </button>
      </s.ModalHeader>
      <s.CvvContainer
        isError={
          popupBase === CvvBase.EVENT
            ? checkCVVError(currentPairItem!.eventThumbnail)
            : false
        }
      >
        {popupBase === CvvBase.EVENT &&
          checkCVVErrorBlocking(currentPairItem!.eventThumbnail) && (
            <s.CvvHeader>
              <img src={WARNIN_CIRCLE_ICON} alt="warning circle icon" />
              CVV has detected obstructions blocking the camera's view. For
              optimal viewing quality, please remove them as soon as possible.
            </s.CvvHeader>
          )}

        <s.CvvThumbnailWrapper>
          <s.ErrorWrapper>
            {popupBase === CvvBase.EVENT &&
              cvvEvent.map((evt, index) => {
                if (
                  data !== null &&
                  currentPairItem!.eventThumbnail[evt] === true
                ) {
                  return <SmallLabel label={evt} color={COLORS.RED} />;
                } else return null;
              })}
          </s.ErrorWrapper>
          <CVVThumbnail
            errorStatus={
              currentPairItem !== undefined && popupBase === CvvBase.REFERENCE
                ? !checkEmpty(currentPairItem!.referenceThumbnail.errorStatus)
                  ? `${currentPairItem!.referenceThumbnail.errorStatus}`
                  : undefined
                : !checkEmpty(currentPairItem!.eventThumbnail.errorStatus)
                ? `${currentPairItem!.eventThumbnail.errorStatus}`
                : undefined
            }
            videoLoss={false}
            thumbnailUrl={`${
              popupBase === CvvBase.EVENT
                ? currentPairItem!.eventThumbnail.url
                : currentPairItem!.referenceThumbnail.url
            }?v=${Date.now()}`}
            eventDate={date}
          />
        </s.CvvThumbnailWrapper>
      </s.CvvContainer>
    </BigPopupNoHeaderTemplate>
  );
}
